import SeoLandingPage from "@/components/SeoLandingPage";
import QuoteTool from "@/components/QuoteTool";
import ItemCalculator from "@/components/ItemCalculator";
import GoogleReviews from "@/components/GoogleReviews";
import MiramarCalculator from "@/components/MiramarCalculator";
import usePricing from "@/hooks/usePricing";
import { SITE, PROVIDER } from "@/seoData";
import { COST_PAGE, buildCostPage } from "@/seoContentV3";

export default function JunkRemovalCost() {
  const canonical = `${SITE}/${COST_PAGE.slug}`;
  const pricing = usePricing();
  const { title, description, h1, lead, sections, faqs } = buildCostPage(pricing);

  const jsonLd = [
    { "@context": "https://schema.org", "@type": "Service", serviceType: "Junk Removal", provider: PROVIDER, areaServed: { "@type": "AdministrativeArea", name: "San Diego County, CA" }, name: "Junk Removal Cost in San Diego", description, url: canonical,
      offers: { "@type": "AggregateOffer", priceCurrency: "USD", lowPrice: String(Math.round(pricing.tiers[0].price * (1 - (pricing.curbsideDiscount ?? 30) / 100))), highPrice: String(pricing.tiers[pricing.tiers.length - 1].price) } },
    { "@context": "https://schema.org", "@type": "FAQPage", mainEntity: faqs.map((f) => ({ "@type": "Question", name: f.q, acceptedAnswer: { "@type": "Answer", text: f.a } })) },
    { "@context": "https://schema.org", "@type": "BreadcrumbList", itemListElement: [
      { "@type": "ListItem", position: 1, name: "Home", item: SITE + "/" },
      { "@type": "ListItem", position: 2, name: "Junk Removal Prices", item: canonical },
    ] },
  ];

  const extra = (
    <>
    <section className="px-5 lg:px-8 py-16 bg-[#0B1E45]" data-testid="cost-quote-tool">
      <div className="max-w-7xl mx-auto">
        <h2 className="font-display font-black tracking-tighter text-3xl lg:text-4xl text-white">Get your junk removal quote and book</h2>
        <p className="text-white/70 mt-2 mb-6 max-w-2xl">Price your load by truck size or by the item, then tap Book. Your booking opens in a new tab.</p>
        <div className="grid lg:grid-cols-2 gap-6 items-stretch">
          <QuoteTool />
          <ItemCalculator />
        </div>
      </div>
    </section>
    <GoogleReviews />
    <div className="px-5 lg:px-8"><MiramarCalculator /></div>
    </>
  );

  const related = [
    { to: "/pricing-and-disposal-guide", label: "San Diego Dump & Landfill Fees" },
    { to: "/services/couch-removal", label: "Couch Removal San Diego" },
    { to: "/services/mattress-removal", label: "Mattress Removal San Diego" },
    { to: "/services/appliance-removal", label: "Appliance Removal San Diego" },
    { to: "/services/garage-cleanout", label: "Garage Cleanout" },
    { to: "/services/estate-cleanout", label: "Estate Cleanup San Diego" },
    { to: "/services/hot-tub-removal", label: "Hot Tub Removal" },
    { to: "/services/junk-pickup", label: "Junk Pickup & Haulers" },
  ];

  return (
    <SeoLandingPage
      config={{ h1, crumb: "Junk Removal Prices", lead, sections, faqs, related, extra,
        benefitsTitle: "Everything included in the price", relatedTitle: "Services & guides",
        seo: { title, description, canonical, jsonLd } }}
    />
  );
}
